export const getElementPositionFromTop = element => {
  const rect = element?.getBoundingClientRect();
  if (rect === undefined) {
    return 0;
  } else {
    return rect.top;
  }
};
